// src/hooks/useEventos.js
import { useState, useEffect, useCallback } from "react";
import getRegistrosEventos from "../API/events/getRegistrosEventos";

// Função auxiliar movida para o hook
const dadosSaoDiferentes = (novosDados, dadosAtuais) => {
  return JSON.stringify(novosDados) !== JSON.stringify(dadosAtuais);
};

const useEventos = () => {
  const [eventos, setEventos] = useState([]);
  const [chamados, setChamados] = useState([]);
  const [loading, setLoading] = useState(true);

  // Função para carregar os eventos
  const carregarEventos = useCallback(async (forceReload = false) => {
    try {
      if (typeof forceReload === 'boolean') {
        setLoading(forceReload);
      } else {
        setLoading(true);
      }
      
      console.log("Buscando eventos e chamados...");
      
      const [eventosData, chamadosData] = await Promise.all([
        getRegistrosEventos(),
      ]);

      console.log(chamadosData);
      
      if (dadosSaoDiferentes(chamadosData, chamados)) {
        setChamados(chamadosData);
      }

    } catch (error) {
      console.error("Erro ao buscar eventos:", error);
    } finally {
      setLoading(false);
    }
  }, [chamados, eventos]);

  // Auto-carregamento com intervalo
  useEffect(() => {
    carregarEventos();

    const interval = setInterval(() => {
      console.log("Verificando atualização de eventos...");
      carregarEventos(false);
    }, 5000);

    return () => clearInterval(interval);
  }, [carregarEventos]);

  return {
    eventos,
    chamados,
    loading,
    carregarEventos
  };
};

export default useEventos;